import React from 'react';

import HomeBanner from '../sections/Banner/CompanyBanner';
import DirectAccess from '../sections/DirectAccess/DirectAccess';
import RedirectionsCards from '../sections/RedirectionCards/RedirectionsCards';
import MetricsCard from './sections/MetricsCard/MetricsCard';
import Ranking from './sections/Ranking/Ranking';

import './DefaultHome.scss';

const DefaultHome = () => {
  return (
    <div className="home-container">
      <div className="first-component">
        <DirectAccess />
      </div>
      <div className="second-component">
        <MetricsCard />
      </div>
      <div className="third-component">
        <Ranking />
      </div>
      <div className="fourth-component">
        <HomeBanner />
      </div>
      <div className="fifth-component">
        <RedirectionsCards />
      </div>
    </div>
  );
};

export default DefaultHome;
